"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRelated = exports.RelatedType = exports.Picker = exports.OverrideStrategy = void 0;
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 * @author Krzysztof Ustowski
 */
var OverrideStrategy;
(function (OverrideStrategy) {
    OverrideStrategy["Push"] = "push";
    OverrideStrategy["Replace"] = "replace";
})(OverrideStrategy = exports.OverrideStrategy || (exports.OverrideStrategy = {}));
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
var Picker;
(function (Picker) {
    Picker["Author"] = "authorPicker";
    Picker["Content"] = "contentPicker";
    Picker["Gallery"] = "galleryPicker";
    Picker["Media"] = "mediaPicker";
    Picker["Set"] = "setPicker";
    Picker["Tag"] = "tagPicker";
})(Picker = exports.Picker || (exports.Picker = {}));
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Krzysztof Ustowski
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
var RelatedType;
(function (RelatedType) {
    RelatedType["Author"] = "author";
    RelatedType["ExtendedAuthor"] = "extended_author";
    RelatedType["Content"] = "content";
    RelatedType["DeduplicatedSet"] = "list_deduplicated";
    RelatedType["File"] = "file";
    RelatedType["Gallery"] = "gallery";
    RelatedType["Label"] = "label";
    RelatedType["Newsletter"] = "newsletter";
    RelatedType["Set"] = "list";
    RelatedType["SmartAuthor"] = "smartAuthor";
    RelatedType["SmartCategory"] = "smartCategory";
    RelatedType["SmartGallery"] = "smartGallery";
    RelatedType["SmartTag"] = "smartTag";
    RelatedType["Tag"] = "tag";
})(RelatedType = exports.RelatedType || (exports.RelatedType = {}));
/**
 * Determines whether the passed-in `input` correctly implements the `Related` interface.
 *
 * @param input - The input to check.
 * @param [type] - The strictly defined `RelatedType` to validate the input against.
 *
 * @typeGuard
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
exports.isRelated = (input, type) => {
    if (typeof input !== 'object' || input === null) {
        return false;
    }
    if (!Object.prototype.hasOwnProperty.call(input, 'type') ||
        typeof input.type !== 'string' ||
        input.type.length === 0) {
        return false;
    }
    if (typeof type !== 'undefined' && input.type !== type) {
        return false;
    }
    // noinspection RedundantIfStatementJS
    if (!Object.prototype.hasOwnProperty.call(input, 'value') ||
        (typeof input.value !== 'number' && typeof input.value === 'string' && isNaN(parseInt(input.value)))) {
        return false;
    }
    return true;
};
//# sourceMappingURL=contracts.js.map